module.exports = __webpack_public_path__ + "img/payment.71f32feb.png";